import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "../../styles/pages.css";
import { getProduct } from "../../api";

const EnProductDetail = () => {
  const { category, productId } = useParams();
  const navigate = useNavigate();
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      (async () => {
        const res = await getProduct({ id: productId });
        const data = res.data;
        setProduct(data);
      })();
      setLoading(false);
    }, 100);
  }, [category, productId, navigate]);

  if (loading) {
    return <div className="loading">loading...</div>;
  }

  if (!product) {
    return <div className="not-found">Cannot find items</div>;
  }

  return (
    <div className="product-detail-container">
      <div className="product-detail-content">
        <h1 className="product-title">{product.name}</h1>
        {product.subtitle && <h2 className="product-subtitle">{product.subtitle}</h2>}
        <div className="product-info-grid">
          <div className="product-specs">
            <table className="specs-table">
              <tbody>
                <tr key="제품">
                  <th>Title</th>
                  <td>{product.en_translations[0].title_en}</td>
                </tr>
                <tr key="카테고리">
                  <th>Category</th>
                  <td>{product.category.en_name}</td>
                </tr>
                <tr key="용량">
                  <th>Capacity</th>
                  <td>{product.en_translations[0].capacity_en}</td>
                </tr>
                <tr key="제조">
                  <th>
                    Manufacture
                    <br />
                  </th>
                  <td>{product.en_translations[0].manufacture_en}</td>
                </tr>
                <tr key="제조사">
                  <th>Manufacturer</th>
                  <td>{product.en_translations[0].manufacturer_en}</td>
                </tr>
                <tr>
                  <th>Content</th>
                  <td dangerouslySetInnerHTML={{ __html: product.en_translations[0].content_en }}></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div className="product-image-container">
          {product.product_img ? <img src={product.product_img[0].file.url} alt={product.name} className="product-detail-image" /> : <div className="placeholder-image">이미지 준비 중</div>}
        </div>
        <div className="product-list-button-container">
          <button className="product-list-button" onClick={() => navigate(`/en/products/${category}`)}>
            on the list
            <svg className="arrow-icon" xmlns="http://www.w3.org/2000/svg" width="74.318" height="9.143" viewBox="0 0 74.318 9.143">
              <path data-name="패스 17" d="M7734.385 1613.134h72.855l-10.653-8.248" transform="translate(-7734.385 -1604.491)" style={{ fill: "none", stroke: "currentColor" }} />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
};

export default EnProductDetail;
